const experienceData = [
  {
    "position": "Software Engineer",
    "company": "Whitson LLC",
    "location": "Houston, TX",
    "startDate": "January 2025",
    "endDate": "June 2026",
    "description": "Led and optimized high-throughput RESTful APIs for the whitson+ SaaS platform. Implemented BFF session handling reducing client-side load times by 30%. Led architectural integration of Auth0 for enterprise IAM. Managed enterprise-scale OpenShift deployments for Aramco.",
    "technologies": [
      "Python/Flask",
      "PostgreSQL",
      "Redis",
      "Auth0",
      "OpenShift",
      "CI/CD"
    ]
  },
  {
    "position": "Master's Thesis Researcher (Computer Science & NLP)",
    "company": "NTNU",
    "location": "Trondheim, NO",
    "startDate": "August 2024",
    "endDate": "June 2025",
    "description": "Designed a modular NLP system to classify cross-ideological extremist rhetoric, fine-tuning DeBERTa and DistilBERT over 1.2M+ text records. Engineered affective-scoring pipelines with PySentimiento, applied MANOVA/ANOVA testing and SHAP interpretability.",
    "technologies": [
      "PyTorch",
      "Transformers",
      "DeBERTa",
      "DistilBERT",
      "SHAP",
      "PySentimiento"
    ]
  },
  {
    "position": "Software Developer",
    "company": "Wiseline AS",
    "location": "Trondheim, NO",
    "startDate": "January 2024",
    "endDate": "December 2024",
    "description": "Developed full-stack web applications for power-line risk management. Improved backend architectures in an agile environment with Git-based workflows.",
    "technologies": [
      "React",
      "Django",
      "Python",
      "Git"
    ]
  },
  {
    "position": "Software Developer Intern",
    "company": "Bouvet ASA (Statens vegvesen / NPRA)",
    "location": "Oslo, NO",
    "startDate": "June 2024",
    "endDate": "July 2024",
    "description": "Led backend for a real-time emergency rerouting module for the national traffic app. Integrated XML/JSON external APIs for dynamic heavy-vehicle routing. Optimized Java parsing algorithms for live weather and road closure data.",
    "technologies": [
      "React",
      "Spring Boot",
      "Java",
      "REST APIs"
    ]
  },
  {
    "position": "Software Developer Intern – Sesam GeniE",
    "company": "DNV – Det Norske Veritas",
    "location": "Hovik, NO",
    "startDate": "June 2023",
    "endDate": "August 2023",
    "description": "Led complex architectural migration of the GeniE structural analysis suite. Decoupled presentation layers from core mathematical logic, refactoring legacy MFC to Qt/C++.",
    "technologies": [
      "C++",
      "Qt",
      "MFC",
      "CMake"
    ]
  },
  {
    "position": "Software Engineer – Bachelor's Thesis",
    "company": "Accenture / NTNU",
    "location": "Trondheim, NO",
    "startDate": "January 2023",
    "endDate": "June 2023",
    "description": "Designed full-stack application for real-time marine telemetry (AIS) and radar data in the Trondheim fjord. Built third-party API integration pipelines for live ship-tracking.",
    "technologies": [
      "Python/Django",
      "PostgreSQL",
      "Azure",
      "React"
    ]
  },
  {
    "position": "Teaching Assistant",
    "company": "NTNU – Faculty of Information Technology and Electrical Engineering",
    "location": "Trondheim, NO",
    "startDate": "August 2021",
    "endDate": "December 2024",
    "description": "Teaching assistant across multiple subjects. Line-by-line code reviews for 50+ student cohorts, technical workshops and 1-on-1 mentorship.",
    "technologies": [
      "Applied ML",
      "C++ for Programmers",
      "Statistics",
      "Databases",
      "Discrete Mathematics",
      "OOP in Java"
    ]
  },
  {
    "position": "Software Engineering – Borrowing Application",
    "company": "IDATT2106 - System Development",
    "location": "Trondheim, NO",
    "startDate": "January 2021",
    "endDate": "May 2021",
    "description": "Led the backend and frontend team. Major implementations in frontend and backend for a borrowing platform.",
    "technologies": [
      "Vue.js",
      "Spring Boot",
      "Java"
    ]
  }
];

export default experienceData;
